import { Skeleton } from "~/components/ui/skeleton";

export const SearchLoading = () => {
  return (
    <div className="flex flex-col gap-3 items-start py-3">
      <Skeleton className="h-4 w-[159px] rounded-md" />
      <Skeleton className="h-4 w-[267px] rounded-md" />
      <Skeleton className="h-4 w-[267px] rounded-md" />
      <Skeleton className="h-4 w-[267px] rounded-md" />
      <Skeleton className="h-4 w-[267px] rounded-md" />
    </div>
  );
};
